import React from "react";

const UnderMaintenance = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>🛠️</div>

        <h1 style={styles.title}>We'll be back soon!</h1>

        <p style={styles.message}>
          Our application is currently undergoing scheduled maintenance to
          improve your experience.
        </p>

        <p style={styles.subMessage}>
          Please check back in a little while. Thank you for your patience.
        </p>

        <button
          style={styles.button}
          onClick={() => window.location.reload()}
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4f6f8",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "500px",
    width: "90%",
  },
  icon: {
    fontSize: "60px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "32px",
    marginBottom: "16px",
    color: "#333",
  },
  message: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "10px",
    lineHeight: "1.6",
  },
  subMessage: {
    fontSize: "16px",
    color: "#777",
    marginBottom: "30px",
  },
  button: {
    background: "#1976d2",
    color: "#fff",
    border: "none",
    padding: "12px 24px",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default UnderMaintenance;